import { MeasureUnitTable } from "../api/biClient.types";

export function checkUnitTable(table: MeasureUnitTable | undefined, check: MeasureUnitTable): boolean {
  if (table === undefined) return false;
  return ((table & check) as MeasureUnitTable) === check;
}
